import { authRoles } from 'app/auth';
import Page from './index';

export default {
settings: {
		layout: {
			config: {
				footer: {
					display: false
				},
			}
		}
	},
	auth: authRoles.agentAndAdmin,
	routes: [
		{
			path: '/service-tickets',
			exact: true,
			component: Page.Layout
		},
		{
			path: '/service-tickets/focus-details',
			exact: true,
			component: Page.FocusModeDetails
		},
		{
			path: '/service-tickets/:id',
			exact: true,
			component: Page.Details
		},
		{
			path: '/alert-list',
			exact: true,
			component: Page.AlertLayout
		},
	]
};